const RESTITUTION_DETAILS = {
  header: 'Restituições',
  title: 'Resumo da Semana',
  defaultErrorMessage: 'Houve um erro, tente novamente mais tarde.',
  details: {
    title: 'Detalhamento',
    question: 'Dúvidas sobre a restituição?',
    helpLink:
      'https://faq-parceiro-zedelivery.sprinklr.com/articles/pagamento/dvidas-sobre-a-restituio/69fa21576d5db755fb02b308',
    summaries: {
      markup: {
        title: 'Markup',
        subtitle: 'Markup na venda dos produtos Ambev.',
        helpLink:
          'https://faq-parceiro-zedelivery.sprinklr.com/articles/pagamento/como-calculada-a-restituio-do-markup/69fa42ee05f37d1b1c9f98ab',
        downloadButtonText: 'markup por pedido',
      },
      shipping: {
        title: 'Fretes',
        subtitle:
          'Diferença entre os valores de entrega negociado com você e os pagos pelo cliente, incluindo taxas adicionais.',
        helpLink:
          'https://faq-parceiro-zedelivery.sprinklr.com/articles/pagamento/como-calculada-a-restituio-dos-fretes/69fa24a56d5db755fb02e919',
        downloadButtonText: 'frete por pedido',
      },
      couponAndDiscount: {
        title: 'Cupons e Descontos',
        subtitle: 'Valores de cupons e descontos aplicados nos pedidos.',
        helpLink:
          'https://faq-parceiro-zedelivery.sprinklr.com/articles/pagamento/como-calculada-a-restituio-de-cupons-e-descontos/69fa252d169cf92e2e5f7405',
        downloadButtonText: 'cupons e descontos por pedido',
      },
      incentive: {
        title: 'Incentivos',
        subtitle:
          'Valores operacionais pagos de acordo com as metas e indicadores atingidos.',
        helpLink:
          'https://faq-parceiro-zedelivery.sprinklr.com/articles/pagamento/como-calculada-a-restituio-dos-incentivos/69fa27356d5db755fb03ad8a',
        downloadButtonText: 'incentivos',
      },
      marketPlace: {
        title: 'Taxas e Comissões',
        subtitle: 'Detalhamento de cobranças como plataforma e marketplace.',
        detailsSummaryLabel: 'Comissão',
        helpLink:
          'https://faq-parceiro-zedelivery.sprinklr.com/articles/pagamento/como-calculada-a-restituio-de-taxas-e-comisses/69fa27b0169cf92e2e5fcdbc',
        downloadButtonText: 'comissões por pedido',
      },
      manualPayment: {
        title: 'Pagamentos Manuais',
        subtitle:
          'Ajustes e correções de valores referentes a períodos passados ou atuais.',
        helpLink:
          'https://faq-parceiro-zedelivery.sprinklr.com/articles/pagamento/como-calculada-a-restituio-dos-pagamentos-manuais/69fa2826169cf92e2e5fd45c',
        downloadButtonText: 'pagamentos manuais',
      },
    },
  },
  detailsAccordion: {
    summaryLabel: 'Restituição',
    helpLinkText: 'Não entendi como foi calculado',
    downloadReportPrefix: 'Baixar relatório de',
    currentWeekMessage:
      'Valor ainda está sendo calculado. Não é possível ter uma pré-visualização antes do fechamento da semana.',
    noDetailsMessage:
      'Não há dados de restituição para a categoria na semana selecionada.',
    discountedValue:
      'Esse valor será descontado no cálculo total da restituição',
    notDiscountedValue:
      'Esse valor não será descontado no cálculo total da restituição',
    errorMessageCardTotalMismatch: 'Restitution details card total mismatch',
  },
  breadcrumb: {
    home: 'Restituições: Resumo das semanas',
    week: 'Semana',
  },
  actions: {
    print: 'Imprimir faturamento',
    download: 'Baixar relatório',
  },
  currentWeek: {
    warning:
      'Valores da página estão sendo atualizados. Essa semana ainda não foi fechada.',
  },
  summary: {
    status: 'Status:',
    previsionDate: 'Previsão de pagamento:',
    period: 'Período de vendas considerado:',
    orders: 'Pedidos',
    total: 'Valor restituído',
    fallback: '--',
    loading: 'Carregando resumo da semana...',
  },
  badge: {
    pending: 'Pendente',
    scheduled: 'Agendado',
  },
  analytics: {
    report: 'Relatório',
    question: 'Dúvidas',
    componentCategory: {
      accordion: 'Accordion',
      breadcrumb: 'Breadcrumb',
      button: 'Button',
      textLink: 'TextLink',
    },
    componentName: {
      print: 'Imprimir faturamento',
      download: 'Baixar relatório',
      breadcrumb: 'Resumo',
    },
  },
}

export default RESTITUTION_DETAILS
